import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account } from '../../../shared/interfaces/account.interfaces';

const basePath = '/dealer/account';

@Injectable({
  providedIn: 'root'
})

export class DealerAccountService {
  constructor(private http: HttpClient) { }

  // Moves accounts from current dealer to a subdealer
  assignAccountsToSubdealer(subdealer_id: number, accounts_ids: number[] ): Observable<Account[]> {
    const body = accounts_ids;
    return this.http.post<Account[]>(`${basePath}/${subdealer_id}`, body);
  }
}
